import React from 'react';
import { Col, Row } from 'reactstrap';
import Raid from '../../assets/img/bugzero/raid-loader.gif';

const Loader = () => (
  <Row className="flex-center py-5">
    <Col xs="auto">
      <img src={Raid} alt="loader" data-testid={'loader'} />
    </Col>
  </Row>
);

export default Loader;
